import { render, staticRenderFns } from "./cusColumns.vue?vue&type=template&id=59d295a0&scoped=true"
import script from "./cusColumns.vue?vue&type=script&lang=js"
export * from "./cusColumns.vue?vue&type=script&lang=js"
import style0 from "./cusColumns.vue?vue&type=style&index=0&id=59d295a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d295a0",
  null
  
)

export default component.exports